import { ResourceType } from '@components/resources/users/table/types';
import { useQueryParams } from '@hooks/queryParams';
import { resourcesRoute } from '@utils/consts';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { useIsPhone } from '@hooks/useIsPhone';

export const useResourceType = () => {
  const [value, setValue] = useState<ResourceType>('office');
  const { pathname } = useLocation();

  const {
    params: { tab },
  } = useQueryParams();

  useEffect(() => {
    if (pathname.includes(resourcesRoute.equipment)) {
      setValue('equipment');
    } else if (pathname.includes(resourcesRoute.fieldWorkers)) {
      setValue((tab || 'fieldUser') as ResourceType);
    } else setValue('office');
  }, [pathname, tab]);

  return value;
};

export const getActive = (status: string[]) => {
  if (status?.length === 2) return;
  if (status?.includes('deactivated')) return false;
  return true;
};

export const RESOURCES_PHONE_PEOPLE_TYPES = ['office', 'field_user', 'crew_member'];

export const useResourcesPhoneView = () => {
  const isPhone = useIsPhone();
  const {
    params: { resourcesView },
  } = useQueryParams();
  if (!isPhone) return undefined;
  return resourcesView === 'equipment' ? 'equipment' : 'people';
};
